export const displayDate = (dateString: string) => {
    if (dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleString("default", { month: "short" });
        const day = `0${date.getDate()}`.slice(-2);
        return `${day} ${month}, ${date.getFullYear()}`;
    }
    return "";
};

export const displayDateAndTime = (dateString: string) => {
    if (dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleString("default", { month: "short" });
        const day = `0${date.getDate()}`.slice(-2);
        let hours = date.getHours();
        const MM = `0${date.getMinutes()}`.slice(-2);
        const AMPM = hours >= 12 ? 'pm' : 'am';
        hours = hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const HH = `0${hours}`.slice(-2);
        return `${day} ${month}, ${date.getFullYear()}, ${HH}:${MM} ${AMPM}`;
    }
    return "";
};